import PropTypes from 'prop-types';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const SkinColorPreview = ({ value, defaultValue = null }) => {
  const { t } = useTranslation('common');
  return !value ? defaultValue : t(`skinColors.${value}`);
};

export default memo(SkinColorPreview);

SkinColorPreview.propTypes = {
  defaultValue: PropTypes.any,
  value: PropTypes.string
};
